import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import Clients, { getClients } from "../helpers/Clients";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";


export default function ClientCreate() {
    const { appState } = useAppState();
    const { register, handleSubmit } = useForm();

    const onSubmit = handleSubmit((values) => {
        Clients.create({
            name: values.name,
            email: values.email,
            description: values.description,
            phone: values.phone,
        })
    });

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Clients \ New client</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <form className="" onSubmit={onSubmit}>
                    <div className="space-y-4">
                        <input
                            {...register('name')}
                            placeholder="Fullname"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                        <input
                            {...register('email')}
                            type="email"
                            placeholder="Email"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                        <input
                            {...register('phone')}
                            type="phone"
                            placeholder="Phone"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                        <input
                            {...register('description')}
                            type="text"
                            placeholder="Description"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />

                        <div className="mt-6 flex items-center justify-end gap-x-6">
                            <Link to="/clients" className="text-sm/6 font-semibold text-gray-900">
                                Cancel
                            </Link>
                            <button
                                type="submit"
                                className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
